import { SortInfo } from '@app/components/nbs-table/nbs-table.component';

export type FilterMETA = {
  filterKey: string;
  metaData: string[];
};

export type FilterMetaData = {
  category?: (string | number)[];
  brand?: (string | number)[];
  package?: (string | number)[];
  consumptionType?: (string | number)[];
};

export type FilterOption = {
  label: string;
  value: string | number;
  metadata?: FilterMetaData[];
};

export type SELECTED_FILTER_VALUES = {
  filterKey: string;
  values: (string | number)[];
  metadata?: string[];
  filterType: FilterType;
  name?: string;
};

export enum FilterType {
  CUSTOMER = 'CUSTOMER_FILTER',
  MATERIAL = 'MATERIAL_FILTER',
  VOID = 'VOID_FILTER',
  REPORT = 'REPORT_FILTERS',
}

export type Preference = {
  filterKey: string;
  values: (string | number)[];
};

export type Filter = {
  filter_key: string;
  options: FilterOption[];
  filter_type: FilterType;
};

export enum OperationType {
  AND = 'AND',
  OR = 'OR',
}

export type FilterGroup = {
  operationType: OperationType;
  filters: SELECTED_FILTER_VALUES[];
};

export type VoidFilterPayload = {
  filters?: SELECTED_VOID_FILTER_VALUES[];
  sort?: SortInfo;
  search?: string;
  page?: PageObj;
};

export type SELECTED_VOID_FILTER_VALUES = {
  filterKey: string;
  values: (string | number)[];
};

export type PageObj = {
  limit: number;
  currentPage: number;
};

export enum SelectAllStatus {
  checked = 'checked',
  indeterminate = 'indeterminate',
  unchecked = 'unchecked',
}
